
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { FaWallet, FaMobileAlt, FaCreditCard } from "react-icons/fa";
export const PaymentMethodDialog = ({ open, onClose, onPay, total }) => {
  const [selectedMethod, setSelectedMethod] = useState("");

  const methods = [
    { id: "cash", label: "Cash", icon: <FaWallet className="w-5 h-5" /> },
    { id: "upi", label: "UPI", icon: <FaMobileAlt className="w-5 h-5" /> },
  ];

  const handleConfirm = () => {
    if (!selectedMethod) {
      alert("Please select a payment method.");
      return;
    }
    onPay(selectedMethod);
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        className:
          "rounded-2xl shadow-xl bg-white dark:bg-gray-900 transition-all",
      }}
    >
      {/* Title */}
      <DialogTitle className="text-lg font-bold text-center border-b border-gray-200 dark:border-gray-700 py-3">
        Select Payment Method
      </DialogTitle>

      {/* Content */}
      <DialogContent className="space-y-4 py-5">
        {/* Total */}
        <div className="text-center">
          <Typography variant="h6" className="font-bold text-green-600">
            ₹{total.toLocaleString()}
          </Typography>
          <Typography variant="body2" className="text-gray-500">
            Total Amount
          </Typography>
        </div>

        {/* Payment Options */}
        <div className="flex flex-col gap-3">
          {methods.map((m) => {
            const isSelected = selectedMethod === m.id;
            return (
              <button
                key={m.id}
                onClick={() => setSelectedMethod(m.id)}
                className={`flex items-center justify-between p-4 rounded-xl border transition-all duration-200
                ${
                  isSelected
                    ? "border-green-500 bg-green-50 shadow-sm"
                    : "border-gray-200 hover:border-green-400 hover:bg-gray-50"
                }`}
              >
                <div className="flex items-center gap-3">
                  <div
                    className={`p-2 rounded-full ${
                      isSelected
                        ? "bg-green-100 text-green-700"
                        : "bg-gray-100 text-gray-600"
                    }`}
                  >
                    {m.icon}
                  </div>
                  <Typography className="font-medium">{m.label}</Typography>
                </div>

                {/* Custom Radio Indicator */}
                <div
                  className={`w-5 h-5 rounded-full border flex items-center justify-center ${
                    isSelected ? "border-green-500" : "border-gray-300"
                  }`}
                >
                  {isSelected && (
                    <div className="w-3 h-3 bg-green-500 rounded-full" />
                  )}
                </div>
              </button>
            );
          })}
        </div>
      </DialogContent>

      {/* Actions */}
      <DialogActions className="border-t border-gray-200 dark:border-gray-700 px-4 py-3">
        <Button
          onClick={onClose}
          variant="outlined"
          className="rounded-full border-2"
        >
          Cancel
        </Button>
        <Button
          onClick={handleConfirm}
          variant="contained"
          className="rounded-full bg-green-600 hover:bg-green-700"
        >
          Confirm & Pay
        </Button>
      </DialogActions>
    </Dialog>
  );
};
